import { render, staticRenderFns } from "./creditor-form.vue?vue&type=template&id=45215a6a&"
import script from "./creditor-form.vue?vue&type=script&lang=js&"
export * from "./creditor-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports